import { transitions as purchaseTransitions } from '../transactions/transactionProcessPurchase';
import { transitions as bookingTransitions } from '../transactions/transactionProcessBooking';

/**
 * Sharetribe transitions after which we void the TEAK order (same id as transaction UUID)
 * so refund protection is not billed when the sale is declined, expired, or canceled/refunded.
 */
const VOID_TEAK_POLICY_TRANSITIONS = new Set([
  purchaseTransitions.DECLINE,
  purchaseTransitions.OPERATOR_DECLINE,
  purchaseTransitions.OPERATOR_DECLINE_FREE,
  purchaseTransitions.EXPIRE,
  purchaseTransitions.OPREATOR_EXPIRE,
  purchaseTransitions.EXPIRE_PAYMENT,
  purchaseTransitions.CANCEL,
  purchaseTransitions.CANCEL_FREE,
  purchaseTransitions.AUTO_CANCEL,
  purchaseTransitions.AUTO_CANCEL_FROM_DISPUTED,
  purchaseTransitions.CANCEL_FROM_DISPUTED,
  bookingTransitions.EXPIRE_PAYMENT,
  bookingTransitions.DECLINE,
  bookingTransitions.OPERATOR_DECLINE,
  bookingTransitions.EXPIRE,
  bookingTransitions.CANCEL,
]);

export const transitionShouldVoidTeakPolicy = transitionName =>
  typeof transitionName === 'string' && VOID_TEAK_POLICY_TRANSITIONS.has(transitionName);
